import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api';
import { CupsService } from '../../../../../services/cups.service';

@Component({
  selector: 'app-soldto-grid',
  templateUrl: './soldto-grid.component.html',
  styleUrls: ['./soldto-grid.component.css']
})
export class SoldtoGridComponent implements OnInit {
  apiResp: any;
  sortedCols: any;
  soldToGridData: any;
  selectedCols: any;
  cols: any;
  showForm = false;
  showView = false;
  selectedRow = {};
  formType = "";
  constructor(private router: Router, private spinner: NgxSpinnerService, private toastr: ToastrService, private _service: CupsService, private confirmationService: ConfirmationService) { }

  ngOnInit() {
    this.cols = [
      {
        "header_id": 1,
        "field": "soldToSalesOrgConfigID",
        "header": "Sold To Sales Org ConfigID",
        "is_show": false,
        "is_editable": false,
        "serial_no": 1
      },
      {
        "header_id": 2,
        "field": "soldTo",
        "header": "Sold To",
        "is_show": true,
        "is_editable": false,
        "serial_no": 2
      },
      {
        "header_id": 3,
        "field": "soldToName",
        "header": "Sold To Name",
        "is_show": true,
        "is_editable": false,
        "serial_no": 3
      },
      {
        "header_id": 4,
        "field": "salesOrg",
        "header": "Sales Org",
        "is_show": true,
        "is_editable": false,
        "serial_no": 4
      }
    ]
    this.getSoldToGrid();
  }

  getSoldToGrid() {
    this._service.getSoldToGridData(0).subscribe((response:any) => {
      this.soldToGridData = response.response;
    });
  }

  addNewDistributor() {
    this.showForm = true;
    this.formType = 'New';
  }

  onSelectRow(rowObject) {
    let { rowData, type } = rowObject;
    this.selectedRow = JSON.parse(JSON.stringify(rowData));
    if (type == 'edit') {
      this.formType = 'Edit';
      this.showForm = true;
    } else {
      this.confirmationService.confirm({
        message: 'Are you sure to delete?',
        header: 'Delete Confirmation',
        icon: 'pi pi-info-circle',
        accept: () => {
          this.deleteSoldTo(rowData);
        },
        reject: () => {
        }
      });
    }
  }

  deleteSoldTo(rowData) {
    this.spinner.show();
    this._service.deleteSoltTo(rowData.soldToSalesOrgConfigID).subscribe(response => {
      this.spinner.hide();
      if (!response['isError']) {
        this._service.displayToastr(response);
        this.selectedRow = { 'soldToSalesOrgConfigID': 0, 'soldTo': '', 'soldToName': '', 'SalesOrg': '' };
        this.getSoldToGrid();
      } else {
        this._service.displayToastr(response);
      }
    })
  }

  backToGrid(_event: any) {
    this.showForm = false;
    this.showView = false;
  }

  sortColumns() {
    this.selectedCols = this.selectedCols.sort((a, b) => {
      return a.serial_no - b.serial_no;
    })
  }

  addNewSoldTo() {
    this.formType = "New";
    this.showForm = true;
  }

  refreshSoldTo(eventvalue) {
    if (eventvalue) {
      this.getSoldToGrid();
    } else {
      this.selectedRow = { 'soldToSalesOrgConfigID': 0, 'soldTo': '', 'soldToName': '', 'SalesOrg': '' };
      this.showForm = false;
    }
  }

}
